module.exports = __webpack_public_path__ + "static/heb_lief-48a8a3d3352d8834c19abeedcdfd807e.mp3";